export default "__VITE_ASSET__Vk6RalsD__"